<div>
    <div class="card">
        <div class="card-header mm-card-header">
            Accounts
        </div>
        <div class="card-body col-md-12">
            <div class="row mb-3 align-items-center d-flex">
                <div class="col-md-3 search-container">
                    <input id="account-search" name="accountSearch" type="text"
                           class="form-control search-input" data-identifier="account-search-input"
                           placeholder="Search by Username, Email or ID"
                           [(ngModel)]="searchTerm" (input)="onSearchTermChange()">
                </div>
                <div class="col-md-3 form-check admin-filter-check">
                    <input id="only-show-org-admins" class="form-check-input" type="checkbox"
                           data-identifier="admin-filter-checkbox" name="onlyShowOrgAdmins"
                           [(ngModel)]="onlyShowOrgAdmins" (change)="onAdminFilterChange()">
                    <label class="form-check-label" for="only-show-org-admins">Only Show Org Admins</label>
                </div>
                <div class="col-md-3 text-end ms-auto">
                    <button type="button" class="btn btn-sm btn-primary" data-identifier="create-universal-id-btn"
                            (click)="onCreateUniversalIdClick()">Create {{ enterpriseLabels.universalIdLabel }}
                    </button>
                </div>
            </div>

            <p-table data-identifier="group-table" [value]="tableData" (onLazyLoad)="customSort($any($event))"
                     [lazy]="true"
                     sortMode="single" sortField="username" [sortOrder]="1" [totalRecords]="totalItems"
                     [scrollable]="true" scrollHeight="650px">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="username" [ngStyle]="{'width':'30%'}" [pSortableColumn]="'username'">
                            {{ enterpriseLabels.universalIdLabel }} Username
                            <p-sortIcon field="username"></p-sortIcon>
                        </th>
                        <th pSortableColumn="disabled" [ngStyle]="{'width':'30%'}">ID
                        </th>
                        <th [ngStyle]="{'width':'20%'}">Org Admin
                        </th>
                        <th pSortableColumn="email" [ngStyle]="{'width':'20%'}" [pSortableColumn]="'email'">Email
                            <p-sortIcon field="email"></p-sortIcon>
                        </th>
                        <th [ngStyle]="{'width':'20%'}">Actions
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td data-identifier="username">
                            <div>
                                {{ item.username }}
                                <span *ngIf="item.locked"><fa-icon [icon]="faLock" class="lock-mark ps-1"></fa-icon></span>
                                <span *ngIf="!item.enabled" class="disabled-user"><span>Disabled</span></span>
                            </div>
                        </td>
                        <td data-identifier="id">
                            <div>{{ item.id }}</div>
                        </td>
                        <td data-identifier="org-admin">
                            <div class="col-md-2 text-center">
                                <input class="form-check-input" type="checkbox"
                                       [value]="false"
                                       (change)="toggleGroupAdminUser(item, $event)"
                                       [checked]="hasEnterpriseAdminRole(item)" (click)="$event.stopPropagation()">
                            </div>
                        </td>
                        <td data-identifier="email">
                            <div>{{ item.email }}</div>
                        </td>
                        <td>
                            <button class="btn btn-sm btn-link m-0 p-0 text-decoration-none font-size-inherit text-nowrap"
                                    data-identifier="impersonation-orgadmin-button"
                                    *ngIf="hasEnterpriseAdminRole(item)"
                                    (click)="onImpersonateOrgAdminClick(item)">
                                Impersonate OrgAdmin
                            </button>
                            <button class="btn btn-sm btn-link m-0 p-0 text-decoration-none font-size-inherit"
                                    data-identifier="impersonation-button"
                                    *ngIf="item.defaultLinkedAccount?.organizationDto?.impersonationUrl"
                                    (click)="onImpersonateOrganizationUserClick(item)">
                                Impersonate
                            </button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr data-identifier="no-records">
                        <td [attr.colspan]="5">
                            <lib-empty-state [message]="'No ' + enterpriseLabels.universalIdLabel + ' and/or Instances are enabled to view any administrators.'"/>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer" *ngIf="!tableData">
                    <tr data-identifier="table-footer">
                        <td [attr.colspan]="5">
                            <lib-pagination *ngIf="totalItems>0"
                                            #pagination
                                            [totalItems]="totalItems"
                                            [currentPage]="currentPage"
                                            (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                            (changeCurrentPage)="onChangeCurrentPage($event)">
                            </lib-pagination>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
